import { Directive, Injectable, OnInit, inject } from '@angular/core';
import { AbstractControl, NgControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { applyValidationMessageResolversStatic } from '@iris/common/modules/fields/validation/validation-message-resolver/provider';
import { ValidationMessageResolver } from '@iris/common/modules/fields/validation/validation-message-resolver/validation-message-resolver';

export const VALID_ALIAS_VALIDATION_PATTERN = /^\w[\w-]*$/;
export const VALID_ALIAS_VALIDATOR_NAME = 'validAlias';
export const VALID_ALIAS_VALIDATOR_TRANSLATION_KEY = 'label.validation.alias';

@Injectable()
class ValidAliasValidationMessageResolver implements ValidationMessageResolver {
  private readonly translateService = inject(TranslateService);

  readonly errorCode = VALID_ALIAS_VALIDATOR_NAME;

  getMessage(): string {
    return this.translateService.instant(VALID_ALIAS_VALIDATOR_TRANSLATION_KEY);
  }
}

@Directive({
  selector: '[valid-alias-validation]',
  standalone: true,
  providers: [
    applyValidationMessageResolversStatic(ValidAliasValidationMessageResolver),
  ],
})
export class ValidAliasValidationDirective implements OnInit {
  private readonly ngControl = inject(NgControl);

  ngOnInit(): void {
    this.ngControl.control.addValidators(validAliasValidator);
  }
}

export function validAliasValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && !new RegExp(VALID_ALIAS_VALIDATION_PATTERN).test(control.value)) {
    return { [VALID_ALIAS_VALIDATOR_NAME]: true };
  }

  return null;
}
